<h1 mat-dialog-title>{{ 'viewerProtocols.protocolList.delete.title' | translate }}</h1>
<button test-id="close-dialog" mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<div mat-dialog-content class="fill" [class.hidden]="isLoading">
  <p class="description dialog-padding" [innerHTML]="warningHTML"></p>
  <div class="table-wrapper">
    <table mat-table [dataSource]="tasks$">
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.label' | translate }}</th>
        <td mat-cell *matCellDef="let row" test-id="row-label">
          <fw-ellipsis [text]="row.label || ''"></fw-ellipsis>
        </td>
      </ng-container>

      <ng-container matColumnDef="container">
        <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.container' | translate | titlecase }}</th>
        <td mat-cell *matCellDef="let row" test-id="row-container">
          <span>{{ row.container }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.assignee' | translate }}</th>
        <td mat-cell *matCellDef="let row" test-id="row-assignee">
          <ng-container *ngIf="row.user.firstname">
            <app-avatar [users]="row.user" [enablePopover]="false" [enableAnimation]="true"></app-avatar>
            <span>{{ row.user.firstname }} {{ row.user.lastname }}</span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef>{{ 'viewerProtocols.protocolList.delete.dueDate' | translate }}</th>
        <td mat-cell *matCellDef="let row" test-id="row-dueDate">
          <span>{{ row.due_date }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.status' | translate }}</th>
        <td mat-cell *matCellDef="let row" test-id="row-dueDate">
          <span>{{ row.status }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
    </table>
    <mat-paginator [pageSize]="10" [length]="totalRows" (page)="loadPage($event.pageIndex)"></mat-paginator>
  </div>
</div>

<ng-container *ngIf="isLoading">
  <fw-loading></fw-loading>
</ng-container>

<div class="action-buttons" mat-dialog-actions align="end">
  <button test-id="close-button" mat-dialog-close mat-stroked-button color="error" (click)="cancel()">{{ 'common.actions.cancel' | translate }}</button>
  <button test-id="delete-continue-button" mat-flat-button color="warn" (click)="confirm()">
    {{ 'viewerProtocols.protocolList.delete.deleteAllButton' | translate }}
  </button>
</div>
